// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportSummary_container__2aZEl","section":"ReportSummary_section__3ZZw9","row":"ReportSummary_row__qSrkm","weaponInvolved":"ReportSummary_weaponInvolved__NETx7"};